"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.outreachEntities = void 0;
var outreachEntities;
(function (outreachEntities) {
    outreachEntities["CALL_ATTEMPTS"] = "callAttempts";
    outreachEntities["PATIENT_ACTIVITIES"] = "patientActivities";
    outreachEntities["COMMUNICATION_PREFERENCES"] = "communicationPreferences";
    outreachEntities["LAST_CALLS"] = "lastCalls";
})(outreachEntities || (exports.outreachEntities = outreachEntities = {}));
